// extracted by mini-css-extract-plugin
export default {"head":"share_head__wnC6y","docImg":"share_docImg__1qDdb"};